import { Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core'
import { Subject, takeUntil } from 'rxjs'

import { PermissionsService } from '../services/permissions.service'

@Directive({
  // @TODO: this needs to be fixed properly
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[appHasPermission]',
  standalone: false,
})
export class HasPermissionDirective implements OnInit, OnDestroy {
  @Input() public appHasPermission: string | string[]

  @Input() public appHasPermissionElse: TemplateRef<any> | null = null

  /**
   * To use this input, you need to pass it as an option in the directive selector:
   *
   * <div *appHasPermission="['intake.view', 'intake.edit']; operator: 'AND'">
   */
  @Input() public appHasPermissionOperator: 'AND' | 'IN' | 'OR' = 'AND'

  private onDestroy$ = new Subject<void>()

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private permissionsSvc: PermissionsService,
  ) { }

  public ngOnInit() {
    this.permissionsSvc.hasPermission(this.appHasPermission, this.appHasPermissionOperator)
      .pipe(
        takeUntil(this.onDestroy$),
      )
      .subscribe((hasPermission) => this.handleVisibility(hasPermission))
  }

  public ngOnDestroy() {
    this.onDestroy$.next()
    this.onDestroy$.complete()
  }

  private handleVisibility(hasPermission: boolean) {
    this.viewContainer.clear()

    if (hasPermission) {
      return this.viewContainer.createEmbeddedView(this.templateRef)
    }

    if (this.appHasPermissionElse) {
      this.viewContainer.createEmbeddedView(this.appHasPermissionElse)
      return
    }
  }
}
